DialogController = App.loadClass 'core::Angular/DialogController'

class exports.DeleteDialogController extends DialogController

    constructor: (@scope, @transitions, @modalInstance) ->
        super(@scope, @transitions, @modalInstance)

        @scope.title ?= 'Delete'
        @scope.item_name ?= 'item'
        @scope.plural ?= false

        # prevent the resizer from messing with it
        @scope.fullpage = false

        # replaces the body of the dialog, if specified
        @scope.replace_body ?= null

        # do stuff for deleting the thing - should return a promise
        @scope.delete ?= () =>
            undefined

    save: () =>
        @setAlert({ type: 'info', msg: 'Deleting...' })
        promise = @scope.delete()

        if promise and promise.then?
            promise.then (response) =>
                jsr = response.data
                if not jsr? or jsr is ''
                    @closeWithAlert({ type: 'success', msg: 'Deleted successfully' }, {})
                else
                    @closeWithAlert(jsr.status, jsr.data, false)
